import React from 'react';
import { Card } from '../UI/Card';
import { BrainCircuit, TrendingUp, GraduationCap, MessageCircle, Network, Share2, Users, LayoutTemplate, Award } from 'lucide-react';
export const TrainingAreas = () => {
  const areas = [{
    title: 'AI Training',
    icon: <BrainCircuit className="w-10 h-10 text-primary" data-id="element-1149" data-mp="9hl5160u9lty" />,
    items: ['AI for Educators', 'AI for Professionals', 'AI for Marketing Teams', 'AI productivity tools', 'AI workflow automation']
  }, {
    title: 'Learning and Development',
    icon: <TrendingUp className="w-10 h-10 text-primary" data-id="element-1150" data-mp="nehwn9os77bw" />,
    items: ['Leadership development', 'Professional growth', 'Workplace productivity', 'Learning systems for organizations']
  }, {
    title: 'Teacher Retooling Programs',
    icon: <GraduationCap className="w-10 h-10 text-primary" data-id="element-1151" data-mp="x4jn284lx1tz" />,
    items: ['Modern teaching methods', 'Digital classroom tools', 'Curriculum innovation', 'Student engagement strategies']
  }, {
    title: 'Communications & Soft Skills',
    icon: <MessageCircle className="w-10 h-10 text-primary" data-id="element-1152" data-mp="1hdwlpvirspcr" />,
    items: ['Professional communication', 'Public speaking', 'Workplace collaboration', 'Emotional intelligence']
  }, {
    title: 'Strategic Networking',
    icon: <Network className="w-10 h-10 text-primary" data-id="element-1153" data-mp="18contek61qj7" />,
    items: ['Relationship building', 'Professional visibility', 'Partnership development', 'Collaboration strategies']
  }, {
    title: 'Social Media & Digital Growth',
    icon: <Share2 className="w-10 h-10 text-primary" data-id="element-1154" data-mp="210kikdq6d8dc" />,
    items: ['Social media strategy', 'Content planning', 'LinkedIn visibility', 'Digital storytelling']
  }, {
    title: 'Community Building & Management',
    icon: <Users className="w-10 h-10 text-primary" data-id="element-1155" data-mp="1rahtupq36gkt" />,
    items: ['Community strategy', 'Engagement systems', 'Online community management', 'Volunteer engagement']
  }, {
    title: 'Program Development',
    icon: <LayoutTemplate className="w-10 h-10 text-primary" data-id="element-1156" data-mp="2jtoek5qv7xb4" />,
    items: ['Program design', 'Learning experience design', 'Impact frameworks', 'Monitoring and evaluation']
  }, {
    title: 'Branding',
    icon: <Award className="w-10 h-10 text-primary" data-id="element-1157" data-mp="d4wg9ymbqvfs" />,
    items: ['Personal branding', 'Corporate branding', 'Brand storytelling', 'Thought leadership']
  }];
  return <section className="py-20 bg-white" data-id="element-1158" data-mp="3f36n35qsqe6">
      <div className="container mx-auto px-4" data-id="element-1159" data-mp="3c79hh1py5qs">
        <div className="text-center mb-16 scroll-animate" data-id="element-1160" data-mp="8cv1a4xruqm2">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4 font-heading" data-id="element-1161" data-mp="8b1pycc7ri7q">
            Training Areas
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1162" data-mp="3ukcno5brdubn">
            Comprehensive capacity building across critical domains for the
            modern workforce.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1163" data-mp="3ljek1o58fotl">
          {areas.map((area, index) => <Card key={index} className="scroll-animate hover-lift border-2 border-gray-100 hover:border-primary/30 group transition-all duration-300" style={{
          transitionDelay: `${index % 3 * 100}ms`
        }} data-id="element-1164" data-mp="1esx5y8gcbj77" data-mpi={index}>
              <div className="p-2" data-id="element-1165" data-mp="1tx9rr6m2v1t7">
                <div className="w-16 h-16 bg-gray-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-primary/10 transition-colors duration-300" data-id="element-1166" data-mp="1tu42nrdg7zxh">
                  {area.icon}
                </div>
                <h3 className="text-xl font-bold text-navy mb-4" data-id="element-1167" data-mp="1xy3i06mzssp9">
                  {area.title}
                </h3>
                <ul className="space-y-3" data-id="element-1168" data-mp="2cmgd71e9a7ip">
                  {area.items.map((item, i) => <li key={i} className="flex items-start text-gray-600" data-id="element-1169" data-mp="2cosqv2czdvpy" data-mpi={i}>
                      <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2 mr-3 flex-shrink-0" data-id="element-1170" data-mp="27nn21fmfyslp"></span>
                      <span data-id="element-1171" data-mp="2lljy8awzgwzu">{item}</span>
                    </li>)}
                </ul>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
};